export interface Video {
  productName: string
  productSku: string
  id: string
  url: string
  thumbnail: string
}

export const videoList: Video[] = [
  {
    productName: 'Urban Make B. Pallet',
    productSku: '87252',
    id: 'd0pZ-h-_s4E',
  },
  {
    productName: 'EGEO Choc High',
    productSku: '59436',
    id: 'wPleYl3BI6Y',
  },
  {
    productName: 'BOTIK ROTINA RESVERATROL - MODELO 1',
    productSku: '55403',
    id: 'eA0mk5gjHGg',
  },
  {
    productName: 'Lily Gardênia',
    productSku: '55363',
    id: '8L01QU4bH4w',
  },
  {
    productName: 'Gel Hidratante Refrescante Facial Cuide-se Bem Feira Maçã Verde',
    productSku: '54804',
    id: 'svXzCvpHdNk',
  },
  {
    productName: 'Pincel de Maquiagem Espiral Acessível Articulado Make B.',
    productSku: '53906',
    id: 'oyqGfhFnY-0',
  },
].map((video) => ({
  ...video,
  url: `https://youtube.com/shorts/${video.id}`,
  thumbnail: `https://img.youtube.com/vi/${video.id}/sddefault.jpg`,
}))
